/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDeleteBranchAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M19 3.586 22.293.293l1.414 1.414L20.414 5l3.293 3.293-1.414 1.414L19 6.414l-3.293 3.293-1.414-1.414L17.586 5l-3.293-3.293L15.707.293z" />
        <path d="M16.486 12c-.533 1.404-1.432 2.43-2.454 3.182-1.343.988-2.918 1.509-4.185 1.718A4.008 4.008 0 0 0 7 14.126V2H5v12.126A4.002 4.002 0 0 0 6 22a4.002 4.002 0 0 0 3.895-3.085c1.576-.22 3.586-.844 5.322-2.122 1.486-1.092 2.756-2.655 3.377-4.793zM4 18a2 2 0 1 1 4 0 2 2 0 0 1-4 0z" />
      </g>
    </g>
  </Icon>
);
export { SvgDeleteBranchAlt as DeleteBranchAlt };
